import "./Humanity.module.css";
import Header from "@/reusable_sections/Header";
import HumanityImpactHero from "./sections/HumanityImpactHero";
import Humanity from "./sections/Humanity";
import Footer from "@/reusable_sections/Footer";
export default function HumanityPage() {
  return <div>
      <Header />
      <HumanityImpactHero />
      <Humanity />
      <Footer />
    </div>;
}